export default {
  sign_in: {
    marketing_cta: 'Need to create your own event? ',
    marketing_url: 'https://fourwaves.com/?utm_source=login&utm_medium=website&utm_campaign=link',
    marketing_aria: 'Learn more about Fourwaves',
    trouble_cta: 'Trouble signing in?',
    trouble_url: 'https://help.fourwaves.com/en/articles/9985717-trouble-signing-in',
    back: 'Go Back',
    sign_in: {
      title: 'Welcome back',
      subtitle: 'Sign in with your existing Fourwaves account.',
      forgot_password: 'Forgot password?',
      cta: 'Sign In',
      cta_waiting: 'Signing In',
      sso_required: 'Single sign-on enabled',
    },
    forgot: {
      title: 'Forgot your password?',
      subtitle: 'To reset your password, please enter the email address of your Fourwaves account.',
      cta: 'Send Reset Link',
      cta_waiting: 'Sending',
    },
    sent: {
      title: 'Link Sent',
      subtitle: "Check your inbox. We've sent a link to reset your password to: {email}.",
      text: "If you don't receive the email, check your spam folder. If no account is associated with this email, no email will be sent.",
      cta: 'Return to Sign In',
    },
    invalid_token: {
      title: 'New link sent to your inbox',
      subtitle: 'We just sent a new link to your inbox as the previous one expired.',
    },
    reset: {
      title: 'Reset your Password',
      subtitle: 'Enter your new password.',
      new: 'New Password',
      confirm: 'Confirm new password',
      cta: 'Submit',
      cta_waiting: 'Submitting',
    },
    reset_success: {
      title: 'Password Has Been Reset',
      subtitle: 'Your password has been successfully reset. You can now sign in with your new password.',
      cta: 'Sign In',
    },
    reset_denied: {
      title: 'Please contact your system administrator',
      message: 'Single Sign-On Users must contact their System Administrator directly to reset their password.',
      link: 'Back to Sign In',
    },
    activate: {
      title: 'Activate your account',
      subtitle: 'One Fourwaves account for all event roles: participant, reviewer and organizer.',
      affiliation: 'Affiliation (University, Company)',
      create_password: 'Create your password',
      cta: 'Next step',
      cta_waiting: 'Processing',
    },
    profile: {
      title: 'Complete your profile',
      subtitle:
        'Help participants learn more about you. This info is optional and can be updated later in your profile.',
      picture: 'Profile Picture',
      bio: 'Bio',
      website: 'Website (personal, company, or lab)',
      linkedin: 'LinkedIn',
      x: 'X',
      newsletter: 'I agree to receive emails from Fourwaves regarding product updates for event organizers.',
      cta: 'Activate and Sign In',
      terms:
        "By submitting this form, you agree to Fourwaves <a class='sign-in-tile__link' href='https://fourwaves.com/terms-of-service/' target='_blank'>Terms of service</a> and  <a class='sign-in-tile__link' href='https://fourwaves.com/privacy-policy/' target='_blank'>Privacy Policy</a>.",
    },
    not_found: {
      title: 'This account cannot be found',
      subtitle: 'The email you used is not linked to an account.',
      cta: 'Back to Sign In',
    },
  },
};
